import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  MatButtonToggleAppearance,
  MatButtonToggleChange,
} from '@angular/material/button-toggle';

/**
 * @title Button toggle appearance
 */
@Component({
    selector: 'toggle-buttons',
    templateUrl: 'toggle-buttons.component.html',
    styleUrls: ['toggle-buttons.component.scss'],
    standalone: false
})
export class ToggleButtonsComponent implements OnInit {
  @Output() viewToggler: EventEmitter<any> = new EventEmitter();
  @Input() appearance!: MatButtonToggleAppearance;
  @Input() currentSelection!: string;
  @Output() currentSelectionChange = new EventEmitter<string>();

  ngOnInit() {}

  toggleSelection(value: string) {
    this.currentSelection = value;
    this.currentSelectionChange.emit(value);
  }
}
